<template>
    <div class="row py-7 py-md-7">
        <div class="col-12 col-md-6 d-flex">

            <!-- Card -->
            <router-link :to="{name: 'genesis-summit'}" class="card mb-6 shadow-light-lg lift lift-lg">

                <!-- Image -->
                <a class="card-img-top" href="#!">

                    <!-- Image -->
                    <img alt="..." class="card-img-top" src="/photos/events/genesis/genesis_cover.jpeg">

                    <!-- Shape -->
                    <div class="position-relative">
                        <div class="shape shape-bottom shape-fluid-x svg-shim text-white">
                            <svg fill="none" viewBox="0 0 2880 480" xmlns="http://www.w3.org/2000/svg">
                                <path clip-rule="evenodd" d="M2160 0C1440 240 720 240 720 240H0V480H2880V0H2160Z" fill="currentColor" fill-rule="evenodd"/>
                            </svg>
                        </div>
                    </div>

                </a>

                <!-- Body -->
                <a class="card-body" href="#!">

                    <!-- Heading -->
                    <h3>
                        Genesis Blockchain Summit @Kolkata
                    </h3>

                    <!-- Text -->
                    <p class="mb-0 text-muted">
                        Genesis Blockchain Summit organized by Department of IT&E, West Bengal, Kolkata.
                    </p>

                </a>

                <!-- Meta -->
                <a class="card-meta mt-auto" href="#!">

                    <!-- Divider -->
                    <hr class="card-meta-divider">

                    <!-- Avatar -->
<!--                    <div class="avatar avatar-sm mr-2">-->
<!--                        <img alt="..." class="avatar-img rounded-circle" src="../../../assets/img/avatars/avatar-1.jpg">-->
<!--                    </div>-->

                    <!-- Author -->
<!--                    <h6 class="text-uppercase text-muted mr-2 mb-0">-->
<!--                        Ab Hadley-->
<!--                    </h6>-->

                    <i class="fe fe-calendar"></i>

                    <!-- Date -->
                    <p class="h6 text-uppercase text-muted mb-0 ml-2">
                        <time datetime="2018-04-13">April 13, 2018</time>
                    </p>

                </a>

            </router-link>

        </div>
        <div class="col-12 col-md-6 d-flex">

            <!-- Card -->
            <router-link :to="{name: 'demo-truvito-wsf'}" class="card mb-6 shadow-light-lg lift lift-lg">

                <!-- Image -->
                <a class="card-img-top" href="#!">

                    <!-- Image -->
                    <img alt="..." class="card-img-top" src="/photos/events/demo_wsf/demo_wsf_cover.jpg">

                    <!-- Shape -->
                    <div class="position-relative">
                        <div class="shape shape-bottom shape-fluid-x svg-shim text-white">
                            <svg fill="none" viewBox="0 0 2880 480" xmlns="http://www.w3.org/2000/svg">
                                <path clip-rule="evenodd" d="M2160 0C1440 240 720 240 720 240H0V480H2880V0H2160Z" fill="currentColor" fill-rule="evenodd"/>
                            </svg>
                        </div>
                    </div>

                </a>

                <!-- Body -->
                <a class="card-body" href="#!">

                    <!-- Heading -->
                    <h3>
                        TruVito – The Good Blockchain Demo @ The World Startup Factory
                    </h3>

                    <!-- Text -->
                    <p class="mb-0 text-muted">
                        Thanks to World Startup Factory, we successfully presented demonstration of www.truvito.io.
                    </p>

                </a>

                <!-- Meta -->
                <a class="card-meta mt-auto" href="#!">

                    <!-- Divider -->
                    <hr class="card-meta-divider">

                    <!-- Avatar -->
<!--                    <div class="avatar avatar-sm mr-2">-->
<!--                        <img alt="..." class="avatar-img rounded-circle" src="../../../assets/img/avatars/avatar-2.jpg">-->
<!--                    </div>-->

                    <!-- Author -->
<!--                    <h6 class="text-uppercase text-muted mr-2 mb-0">-->
<!--                        Adolfo Hess-->
<!--                    </h6>-->

                    <i class="fe fe-calendar"></i>

                    <!-- Date -->
                    <p class="h6 text-uppercase text-muted mb-0 ml-2">
                        <time datetime="2018-03-29">March 29, 2018</time>
                    </p>

                </a>

            </router-link>

        </div>
        <div class="col-12 col-md-6 d-flex">

            <!-- Card -->
            <router-link :to="{name: 'summit-wsf'}" class="card mb-6 shadow-light-lg lift lift-lg">

                <!-- Image -->
                <a class="card-img-top" href="#!">

                    <!-- Image -->
                    <img alt="..." class="card-img-top" src="/photos/events/summit_wsf/summit_wsf_cover.jpeg">

                    <!-- Shape -->
                    <div class="position-relative">
                        <div class="shape shape-bottom shape-fluid-x svg-shim text-white">
                            <svg fill="none" viewBox="0 0 2880 480" xmlns="http://www.w3.org/2000/svg">
                                <path clip-rule="evenodd" d="M2160 0C1440 240 720 240 720 240H0V480H2880V0H2160Z" fill="currentColor" fill-rule="evenodd"/>
                            </svg>
                        </div>
                    </div>

                </a>

                <!-- Body -->
                <a class="card-body" href="#!">

                    <!-- Heading -->
                    <h3>
                        New Business Summit 2018 @World Startup Factory
                    </h3>

                    <!-- Text -->
                    <p class="mb-0 text-muted">
                        Launch event of Truvito-The Good Blockchain at New Business Summit of World Startup Factory on 25th January, 2018.
                    </p>

                </a>

                <!-- Meta -->
                <a class="card-meta mt-auto" href="#!">

                    <!-- Divider -->
                    <hr class="card-meta-divider">

                    <i class="fe fe-calendar"></i>

                    <!-- Date -->
                    <p class="h6 text-uppercase text-muted mb-0 ml-2">
                        <time datetime="2018-01-25">January 25, 2018</time>
                    </p>

                </a>

            </router-link>

        </div>
        <div class="col-12 col-md-6 d-flex">

            <!-- Card -->
            <router-link :to="{name: 'wsf-opening'}" class="card mb-6 shadow-light-lg lift lift-lg">

                <!-- Image -->
                <a class="card-img-top" href="#!">

                    <!-- Image -->
                    <img alt="..." class="card-img-top" src="/photos/events/wsf_opening/wsf_opening_cover.jpg">

                    <!-- Shape -->
                    <div class="position-relative">
                        <div class="shape shape-bottom shape-fluid-x svg-shim text-white">
                            <svg fill="none" viewBox="0 0 2880 480" xmlns="http://www.w3.org/2000/svg">
                                <path clip-rule="evenodd" d="M2160 0C1440 240 720 240 720 240H0V480H2880V0H2160Z" fill="currentColor" fill-rule="evenodd"/>
                            </svg>
                        </div>
                    </div>

                </a>

                <!-- Body -->
                <a class="card-body" href="#!">

                    <!-- Heading -->
                    <h3>
                        World Startup Factory - Opening Celebration of Impact Accelerator #3
                    </h3>

                    <!-- Text -->
                    <p class="mb-0 text-muted">
                        Qlikchain was proud addition to the World Startup Factory portfolio and was there at the Opening Celebration of Impact Accelerator #3!
                    </p>

                </a>

                <!-- Meta -->
                <a class="card-meta mt-auto" href="#!">

                    <!-- Divider -->
                    <hr class="card-meta-divider">

                    <i class="fe fe-calendar"></i>

                    <!-- Date -->
                    <p class="h6 text-uppercase text-muted mb-0 ml-2">
                        <time datetime="2017-12-12">December 12, 2017</time>
                    </p>

                </a>

            </router-link>

        </div>
    </div>
</template>

<script>
    export default {
        name: "MediaHome"
    }
</script>

<style scoped>

</style>